import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {collection, query, where, orderBy, limit, getDocs,} from 'firebase/firestore';
import { db } from '../../utils/firebase';
import { FaArrowLeft } from 'react-icons/fa';
import {useAuth} from "../../context/AuthContext";
import {useLang} from "../../context/LanguageContext";
import Footer from "../../components/Footer";


const ReviewsPage = () => {
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const {hasPaid} = useAuth();
  const {language} = useLang();

  useEffect(() => {

    async function fetchReviews() {
      setLoading(true);
      setError(null);
      const temp = [];

      try {
        const colRef = collection(db, 'reviews');
        const q = query(
            colRef,
            where('status', '==', true),
            where('language', '==', language),
            orderBy('timeStamp', 'desc'),
            limit(200)
        );
        const snapshot = await getDocs(q);

        snapshot.forEach((docSnap) => {
          const data = docSnap.data();
          temp.push({
            id: docSnap.id,
            name: data.nume || 'anonymous',
            message: data.mesajReview || '',
            stars: data.numarStele || '0',
            dateMesaj: data.dataMesaj || '',
            timeStamp: data.timeStamp || 0,
          });
        });

      } catch (err) {
        console.error('Error fetching reviews:', err);
        setError('Failed to load reviews.');
      } finally {
        setLoading(false);
      }


      setReviews(temp);
    }

    fetchReviews();
  }, [language]);



  return (
    <div className="relative bg-gray-100 min-h-screen p-5">
      <button
        onClick={() => navigate(-1)}
        className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
      >
        <FaArrowLeft />
        <span className="text-white">Back</span>
      </button>

      <h1 className="text-xl font-bold text-center mt-16 mb-4">Reviews</h1>

      {loading && <p>Loading reviews...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {!loading && reviews.length === 0 && <p>No reviews found.</p>}

      <div className="space-y-4">
        {reviews.map((rev) => (
          <ReviewCard key={rev.id} review={rev} />
        ))}
      </div>


      {hasPaid && (
        <button
          onClick={() => navigate('/reviews/new')}
          className="bg-green-500 text-white font-bold py-2 px-4 rounded fixed bottom-5 left-1/2 transform -translate-x-1/2"
        >
          LEAVE A REVIEW
        </button>
      )}
      <Footer />
    </div>
  );
};

function ReviewCard({ review }) {
  const starCount = parseFloat(review.stars) || 0;

  return (
    <div className="bg-white rounded shadow p-4">
      <div className="flex items-center mb-1">
        {[1, 2, 3, 4, 5].map((i) => (
          <span key={i} className="text-yellow-500 mr-1">
            {i <= starCount ? '★' : '☆'}
          </span>
        ))}
      </div>

      <p className="font-semibold text-sm">{review.name}</p>
      <p className="text-sm text-gray-700 mt-2">{review.message}</p>
      <p className="text-xs text-gray-500 mt-2">{review.dateMesaj}</p>
    </div>
  );
}

export default ReviewsPage;
